import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  fetchTransferCashByCodeCreateSuccess,
  fetchTransferCashByCodeCreateFailure,
  fetchTransferCashByCodeConfirmSuccess,
  fetchTransferCashByCodeConfirmFailure,
  fetchTransferCashByCodeAuthorizationSuccess,
  fetchTransferCashByCodeAuthorizationFailure,
} from "./actions";
import {
  FETCH_TRANSFER_CASH_BY_CODE_CREATE_REQUEST,
  FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_REQUEST,
  FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_REQUEST,
} from "./actions.type";

import {
  fetchTransferCashByCodeCreateService,
  fetchTransferCashByCodeConfirmService,
  fetchTransferCashByCodeAuthService,
} from "../services/transfer-cash-by-code.service";
import { hideModal, showModal } from "app/modules/modal-management/reducer/action";
import { RESPONSEBASE } from "app/shared/services/services-model.type";
import { getErrorMessage } from "app/shared/services/axios";

function* fetchTransferCashByCodeCreateSaga() {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(fetchTransferCashByCodeCreateService);
    console.log("fetchTransfer247AccountDetail response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTransferCashByCodeCreateSuccess(response?.data?.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    yield put(fetchTransferCashByCodeCreateFailure());
    getErrorMessage(e, true);
  }
}

function* fetchTransferCashByCodeConfirmSaga() {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(fetchTransferCashByCodeConfirmService);
    console.log("fetchTransfer247AccountDetail response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTransferCashByCodeConfirmSuccess(response?.data?.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    yield put(fetchTransferCashByCodeConfirmFailure());
    getErrorMessage(e, true);
  }
}

function* fetchTransferCashByCodeAuthSaga() {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(fetchTransferCashByCodeAuthService);
    console.log("fetchTransfer247AccountDetail response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTransferCashByCodeAuthorizationSuccess(response?.data?.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    yield put(fetchTransferCashByCodeAuthorizationFailure());
    getErrorMessage(e, true);
  }
}

function* transferCashByCodeSaga() {
  yield all([
    takeLatest(FETCH_TRANSFER_CASH_BY_CODE_CREATE_REQUEST, fetchTransferCashByCodeCreateSaga),
    takeLatest(FETCH_TRANSFER_CASH_BY_CODE_CONFIRM_REQUEST, fetchTransferCashByCodeConfirmSaga),
    takeLatest(FETCH_TRANSFER_CASH_BY_CODE_AUTHORIZATION_KEY_REQUEST, fetchTransferCashByCodeAuthSaga),
  ]);
}

export default transferCashByCodeSaga;
